module.exports = __webpack_public_path__ + "img/credit-card-logos.329f7c77.svg";